import { useParams } from 'react-router-dom';
import classes from './PlayListItems.module.css';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PlayListItem from './playListItem/PlayListItem';
import InfiniteScroll from "react-infinite-scroll-component";
import { LanguageContext } from '../../../../context/LanguageContext';
import fetchUpdatePlayList from '../../../../store/cartoons/updateCartoonPlaylist/FetchUpdatePlaylist';

const PlayListItems = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const [isDelete, setIsDelete] = useState(false);
  const updatePlayList = useSelector((state) => state.updatePlayList);
  const { playListData, setIsInitialLoded, setIsLoading, loadMore, moreItemsExists} = props;
  const scrollableDiv = document.getElementsByClassName('infinite-scroll-component__outerdiv')
  const checkedPlaylists = JSON.parse(window.sessionStorage.getItem('checkedPlaylists')) ?? []
  
  if(scrollableDiv && scrollableDiv[0]) {
    scrollableDiv[0].style.width = '100%'
  }

  const deleteCartoonHandler = (removeCartoonId) => {
    setIsDelete(true);
    const filteredData = checkedPlaylists?.filter((item) => item !== removeCartoonId)
    window.sessionStorage.setItem('checkedPlaylists', JSON.stringify(filteredData))
    dispatch(fetchUpdatePlayList(params.id, null, null, removeCartoonId));
  };

  useEffect(() => {
    if (isDelete && updatePlayList.updatePlayList.status === 200) {
      window.location.reload();
      setIsDelete(false);
      setIsLoading(true);
    }
  }, [isDelete, updatePlayList, setIsLoading]);

  return (
    <LanguageContext.Consumer>
      {(ctx) => {
        return (
          <div
            id='scrollableDiv'
            className={`${classes.max_width_800} ${classes.playlist_item_container} ${classes.gap_20} d-flex flex-column w-100 overflow-hidden h-100`}>
              <InfiniteScroll
                pageStart={0}
                next={loadMore}
                className={`${classes.gap_20} ${classes.paddingRight_bottom_20} w-100 flex-wrap d-flex`}
                hasMore={moreItemsExists}
                initialLoad={false}
                dataLength={playListData.length}
                scrollableTarget="scrollableDiv"
              >
            {playListData.map((item) => {
              return (
                <PlayListItem
                  src={item?.imageUrl}
                  key={item._id}
                  title={item?.title[ctx.language]}
                  authorName={item?.author[ctx.language]}
                  data={item}
                  playListData={playListData}
                  setIsInitialLoded={setIsInitialLoded}
                  deleteCartoonHandler={() => deleteCartoonHandler(item._id)}
                />
              );
            })}
            </InfiniteScroll>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  );
};

export default PlayListItems;